
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHdAppGrid extends Serenity.EntityGrid<PsAdvPromoHdAppRow, any> {
        protected getColumnsKey() { return PsAdvPromoHdAppColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHdAppDialog; }
        protected getIdProperty() { return PsAdvPromoHdAppRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHdAppRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHdAppRow.localTextPrefix; }
        protected getService() { return PsAdvPromoHdAppService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }

        protected getQuickFilters() {
            let filters = super.getQuickFilters();
            
            filters.push({
                field: 'PromoStatus',
                type: Serenity.IntegerEditor,
                title: 'สถานะ',
                handler: h => {
                    h.value = 0;
                    h.active = true;
                    h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                        [['PromoStatus'], '=', 0]
                    );
                }
            });

            return filters;
        }
    }
}